import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import EmployeeConfig from '../../../../services/api/EmployeeConfig'

const { Employee_NotificationsInbox_Endpoints } = EmployeeConfig
const SELF_BFF_API = process.env.REACT_APP_SELF_BFF_BASE_URL

const resetState = {
  pageNumber: 0,
  activeSearch: '',
  updatedItem: {},
}

export const notificationInboxResetAlertHandler = createAsyncThunk(
  'notificationInbox/notificationInboxResetAlertHandler',
  async () => ({}),
)

export const retrieveNotificationInboxWithQueries = createAsyncThunk(
  'notificationInbox/retrieveNotificationInboxWithQueries',
  async ({ queries, resetQueries }, { getState, rejectWithValue }) => {
    const apiUri = Employee_NotificationsInbox_Endpoints();
    const { notificationInbox } = getState()

    const endpoint = apiUri.notificationsInbox;

    const queryObject = createReqHelper(notificationInbox, resetQueries ? resetState : queries);

    const response = await axios.get(`${SELF_BFF_API}/${endpoint}`, { params: queryObject })

    if (response.status >= 300) {
      return rejectWithValue(response);
    }

    return {
      response: response.data,
      queries: resetQueries ? resetState : queries,
    };
  },
)

export const retrieveNotificationInboxDetails = createAsyncThunk(
  'notificationInbox/retrieveNotificationInboxDetails',
  async ({ queries }, { rejectWithValue }) => {
    const apiUri = Employee_NotificationsInbox_Endpoints(queries)
    const response = await axios.get(`${SELF_BFF_API}/${apiUri.notificationsInboxDetails}`)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }
    return response.data
  },
)
export const retrieveNotificationInboxHistory = createAsyncThunk(
  'notificationInbox/retrieveNotificationInboxHistory',
  async ({ queries }, { rejectWithValue }) => {
    const apiUri = Employee_NotificationsInbox_Endpoints(queries)
    const response = await axios.get(`${SELF_BFF_API}/${apiUri.notificationsInboxRequestHistory}?include_pending=false`)
    if (response.status >= 300) {
      return rejectWithValue(response)
    }
    return response.data
  },
)
export const notificationsInboxActions = createAsyncThunk(
  'notificationInbox/notificationsInboxActions',
  async ({ action, queries }, { rejectWithValue }) => {
    const apiUri = Employee_NotificationsInbox_Endpoints(action)
    const response = await axios.post(`${SELF_BFF_API}/${apiUri.notificationsInboxActions}`, queries)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return response.data
  },
)
export const getNotificationsInboxBell = createAsyncThunk(
  'notificationInbox/getNotificationsInboxBell',
  async (_, { rejectWithValue }) => {
    const apiUri = Employee_NotificationsInbox_Endpoints()
    const response = await axios.get(`${SELF_BFF_API}/${apiUri.notificationInboxBell}`)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return response.data
  },
)
export const NotificationsInboxActionsBulk = createAsyncThunk(
  'notificationInbox/NotificationsInboxActionsBulk',
  async ({ action, queries }, { rejectWithValue }) => {
    const apiUri = Employee_NotificationsInbox_Endpoints(action)
    const response = await axios.post(`${SELF_BFF_API}/${apiUri.notificationsInboxSelected}`, queries)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return response.data
  },
)
function createReqHelper(store, filters = {}) {
  const copyStore = { ...store, ...filters }

  const {
    activeSearch,
    pageSize,
    pageNumber,
  } = copyStore
  const response = {
    search: activeSearch,
    page_number: pageNumber || 0,
    page_size: pageSize || 9,
  }
  return response
}
